module.exports = __webpack_public_path__ + "static/media/Illus-StoreOpening@2x.7740a05e.png";